<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">
        {{ form.id == 0 ? "CREATE" : "UPDATE" }} CONVERSATION TOPIC
      </p>
    </template>
    <b-row no-gutters>
      <b-col cols="9">
        <InputText
          v-model="form.name"
          name="form.name"
          textFloat="Name"
          placeholder="Name"
          type="text"
          isRequired
          :isValidate="$v.form.name.$error"
          :v="$v.form.name"
        />
      </b-col>
      <b-col cols="3" class="pl-3">
        <InputText
          v-model="form.sortOrder"
          textFloat="Sort Order"
          placeholder="Sort Order"
          type="text"
          isRequired
          :isValidate="$v.form.sortOrder.$error"
          :v="$v.form.sortOrder"
        />
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button :disabled="isLoading" class="cancel-button" @click="hide()">
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required, integer, minValue } from "vuelidate/lib/validators";

export default {
  name: "ModalCreateOrEdit",
  components: {
    InputText,
  },
  validations() {
    return {
      form: {
        name: { required },
        sortOrder: {
          required,
          integer,
          minValue: minValue(0),
        },
      },
    };
  },
  data: function () {
    return {
      showModal: false,
      form: {
        id: 0,
        name: "",
        sortOrder: "",
        isActive: true,
      },
      isLoading: false,
    };
  },
  methods: {
    show(item) {
      this.$v.$reset();
      if (item === null) {
        this.form = {
          id: 0,
          name: "",
          sortOrder: "",
          isActive: true,
        };
      } else this.form = { ...item };
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;

      await this.axios
        .post(`${this.$baseUrl}/FlowBuilder/Topics`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.$emit("reloadData");
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
      this.isLoading = false;
    },
  },
};
</script>
